'use client'

import { getPublicEnv } from '@tucan/utils'
import { isBrowser } from '@/utils/is.browser'
import debug from 'debug'
import { FC, useMemo } from 'react'

interface Props {
  env: any
}

export const EnvProviderClient: FC<Props> = ({ env }) => {
  useMemo(() => {
    if (isBrowser()) {
      global.env = env

      window.dispatchEvent(new Event('process.env'))
    }

    debug.enable(getPublicEnv('DEBUG'))
  }, [])

  return null
}
